/**
 * 竞价车辆信息项目
 */
import React from 'react';
import { numFormat } from '../../../util/util'
import moment from 'moment';
import auctionLogoImg from "./img/auctionLogo.jpg";
import http from '../../../axios/http';

const cityMap = {
    "xm": "厦 门",
    "fz": "福 州",
    "sy": "沈 阳",
    "km": "昆 明",
    "pt": "莆 田",
    "st": "汕 头",
    "qz": "泉 州",
    "nn": "南 宁",
    "cc": "长 春",
    "ly": "龙 岩",
    "xa": "西 安"
}

class AuctionedRegion extends React.Component {

    /**
     * region: xm,fz,sy,km
     * session: sessionName,sessionId,session
     * 
     */
    state = {
        open: false
    }

    lotsDetail = () => {
        const { open, url, lotsId } = this.state;
        if (open) {
            window.open(url, "lotsDetail-" + lotsId);
        }
    }

    getWatermarkImage = (url) => {
        http.post({
            url: "/common/getWatermarkImage",
            data: { url: url },
            success: (res) => {
                this.setState({
                    base64Image: "data:image/jpeg;base64," + res,
                })
            }
        })
    }

    componentDidMount() {
        const { session } = this.props;
        this.initData(session);
    }

    componentWillReceiveProps(nextProps) {
        const { session } = nextProps;
        this.initData(session);
    }

    initData = (session) => {
        let status = session ? session.status : 2;
        if (status === 0) {
            //即将开始的场次，还需要判断这个场次是否进入倒计时
            let startTime = moment(session.startTime);
            let diff = startTime.diff(new moment(), "minutes");
            //如果即将开始的场次与当前时间相聚小于60分钟，则进入竞价倒计时页面
            if (diff > 1440 || !session.lotsInfo) {
                http.get({
                    url: "/auction/largescreen/findLotsList",
                    data: {
                        sessionId: session.id
                    },
                    success: (lots) => {
                        let url = window.location.origin + "/large/lotsDetail/" + lots[0].id;
                        this.getWatermarkImage(lots[0].vehicleImageUrl);
                        this.setState({
                            lotsId: lots[0].id,
                            url: url,
                            image: lots[0].vehicleImageUrl,
                            open: true,
                        })
                    }
                });

            }
            else {
                let lotsId = session.lotsInfo.lotsId;
                let sessionId = session.id;
                let url = window.location.origin + "/large/auctioning?sessionId=" + sessionId + "&lotsId=" + lotsId;
                this.getWatermarkImage(session.lotsInfo.vehicleInfo.leftFrontImage);
                this.setState({
                    lotsId: lotsId,
                    url: url,
                    open: true,
                    image: session.lotsInfo.auctionLotVO.vehicleImageUrl,
                })
            }
        }
        else 
        if (status === 1) {
            let sessionId = session.id;
            let lotsId = session.lotsInfo.lotsId;
            let url = window.location.origin + "/large/auctioning?sessionId=" + sessionId + "&lotsId=" + lotsId;
            this.getWatermarkImage(session.lotsInfo.vehicleInfo.leftFrontImage);
            this.setState({
                lotsId: lotsId,
                url: url,
                open: true,
                image: session.lotsInfo.auctionLotVO.vehicleImageUrl,
            })
        }
        else {
            this.setState({
                lotsId: null,
                url: null,
                open: false,
                image: null,
                base64Image: null
            })
        }
    }

    render() {
        const { region, session } = this.props;
        let status = session ? session.status : 2;
        let lotsInfo = null;
        if (session) {
            lotsInfo = session.lotsInfo;
        }
        let records = null;
        if (lotsInfo) {
            records = lotsInfo.records;
        }
        let itemClassName = 'auction-item';
        if (this.props.center) {
            itemClassName = 'auction-item center-item';
        }
        let image = this.state.base64Image;
        if (!image) {
            image = auctionLogoImg;
        }
        let title = "没有竞价场次数据";
        if (status === 0) {
            title = session.name;
        }
        return (
            <div className={itemClassName} onClick={this.lotsDetail.bind(this)}>
                <div className='auction-img' style={{ backgroundImage: "url(" + image + ")" }}>
                    {status !== 2 ? <div className='auction-img-bottom' style={{ height: "30px", lineHeight: "30px" }}>
                        <span className="session-title-time" style={{ fontSize: "16px" }}><span className='iconfont icon-clock red-color'></span>&nbsp;{session.startTime}  </span>
                        <div className='gradient-div' style={{ fontSize: "16px", height: "100%" }}>
                            <div style={{ textAlign: "center", fontWeight: "bold", lineHeight: "25px", color: "#fff" }}>
                                {status === 0 ? "即将开始" : "竞价中"}
                            </div>
                            {/* <img className="complete-img" src={status === 2 ? completeImg : waitBeginImg} alt="complete-img" /> */}
                        </div>

                    </div> : ""}
                    <div className="region-tag" style={{
                        position: "absolute", top: "-5px", right: "-64px", fontSize: "30px", transform: "rotate(45deg)",
                        color: "white", fontWeight: "bolder", backgroundColor: "rgba(141, 21, 54, 0.5)", width: "200px", height: "90px", textAlign: "center", lineHeight: "90px"
                    }}>{cityMap[region]}</div>
                </div>
                <div className='auction-detail'>
                    {status === 1 ? <div><div className='car-name' style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {session.name}<br />
                        {status === 1 ? lotsInfo.auctionLotVO.name : ""}
                    </div>
                        {status === 1 ? <div>
                            <div className='price-info'>
                                <span className='item-price-label'>最高价</span>&nbsp;&nbsp;
                                    <span className='item-price-tag red-color'>{records && records.length > 0 ? "￥" + numFormat(records[0].offer) : ''}</span><br />
                                <span className='item-price-label'>起始价</span>&nbsp;&nbsp;
                                    <span className='item-price-label'>￥{numFormat(lotsInfo.auctionLotVO.startPrice)}</span>
                            </div>
                            <div className='follow-box'>
                                <span className='follow-label'><span className='follow-label red-color font-Gilroy'>{records ? records.length : '0'}</span> &nbsp;&nbsp;人出价</span><br />
                                <span className='follow-label'><span className='follow-label red-color font-Gilroy'>{lotsInfo.auctionLotVO.followNum ? lotsInfo.auctionLotVO.followNum : '0'}</span> &nbsp;&nbsp;人关注</span><br />
                            </div>
                        </div> : ""}
                    </div>
                        :
                        <div style={{ textAlign: "center", height: "13.89vh", lineHeight: "13.89vh", fontSize: "16px", fontWeight: "bold" }}>
                            {title}
                        </div>}

                </div>
            </div>
        );
    }
}
export default AuctionedRegion;